// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "20260930.1790797355/static/js/" + chunkId + "." + {"249":"21be09b4","463":"8a875d0b"}[chunkId] + ".chunk.js";
};